//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Divider from "../../../node_modules/vux/src/components/divider/index.vue";

  export default {
    components: {Divider},
    data(){
      return {
        radio:'',
        find:'',
        patientid: this.$store.state.userInfo.id,
        addressTitle:[],
        orederId: this.$route.query.orederId,
      }
    },
    methods:{
      getcodes(items,type){
        this.$store.state.addressList=items;
        this.$store.state.basePzzy.jiuzhenren=items;
//        localStorage.setItem("pzzypatients", JSON.stringify(items));
        this.$router.push({path: '/pzzyManage',query:{id: this.orederId==null?this.$store.state.orderAddress:this.orederId, befrom: 'orderList', addressType: type, addressInfo: items, isDelivery: 1,addressId: items.id}});
      },
      addAddress(){
        if(this.addressTitle.length<=0){
        this.$router.push({path: '/pzzypatientAdd',query: {patientid: this.patientid}});
        }else{
          this.$router.push({path: '/pzzypatientDaa',query: {patientid: this.patientid}});
        }
        },
      getMyAddress(){
        let params = {
          parameters: this.patientid
        };
        let _this=this;
        this.$doRequest("/api/inquiryPeople/getPatientInquiryPatient", params, res=>{
          _this.addressTitle=res.parameters;
        })
      },
      editClick(item){
        this.$router.push({path: '/pzzypatientAdd',query:{id:item,orederId: this.orederId}});
      },
      delClick(item){
        let _this=this;
        if(item.relationCode=='br'){
          _this.$toastMsg('本人关系不允许删除');
          return
        }
        this.$doRequest("/api/inquiryPeople/updateInquiryPeople", {id:item.id,state:'2',relationId:item.relationId}).then(res => {
          if(res.result == 0){
            _this.$toastMsg('删除成功');
            _this.getMyAddress();
          }
        })
      },
      queryDoctor(){
        this.pagination = 1;
        this.patientid=this.find;
        this.getMyAddress();
      }

    },
    created(){
      document.title = '就诊人管理';
      this.orederId = this.$route.query.id;
    },
    mounted(){
      this.getMyAddress();
    }
  }



// WEBPACK FOOTER //
// ./src/views/pzzypatientEdit/index.vue